import React, { useState } from 'react';
import { addMissedSubscribers } from '../scripts/addMissedSubscribers';

const RestoreSubscribers = () => {
  const [results, setResults] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleRestore = async () => {
    setIsProcessing(true);
    try {
      const restorationResults = await addMissedSubscribers();
      setResults(restorationResults);
    } catch (error) {
      setResults([{ success: false, error: error.message }]);
    }
    setIsProcessing(false);
  };

  return (
    <div className="max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">Restore Missed Subscribers</h2>
      
      <div className="mb-6">
        <button
          onClick={handleRestore}
          disabled={isProcessing}
          className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700 transition-colors disabled:opacity-50"
        >
          {isProcessing ? 'Processing...' : 'Restore Missed Subscribers'}
        </button>
      </div>

      {results && (
        <div className="mt-4">
          <h3 className="font-semibold mb-2">Results:</h3>
          {results.map((result, index) => (
            <div
              key={index}
              className={`p-3 rounded mb-2 ${
                result.success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
              }`}
            >
              <p className="text-sm">
                {result.email}: {result.success ? 'Successfully added' : `Failed - ${result.error}`}
              </p>
              {result.id && (
                <p className="text-xs text-gray-600 mt-1">ID: {result.id}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RestoreSubscribers; 